import { render, staticRenderFns } from "./TeetTimesFooter.vue?vue&type=template&id=063319fc"
import script from "./TeetTimesFooter.vue?vue&type=script&lang=js"
export * from "./TeetTimesFooter.vue?vue&type=script&lang=js"
import style0 from "./TeetTimesFooter.vue?vue&type=style&index=0&id=063319fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports